<template>
  <div>
    <b-modal
      id="printMe"
      body-class="payment-status-modal"
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title mr-2">繳款情形</h5>

        <b-button size="sm" variant="warning" @click="convertPdf()">下載PDF</b-button>

        <button type="button" aria-label="Close" class="close" @click="close()">×</button>
      </template>

      <html-to-pdf ref="htmlToPdf" :isHide="false">
        <template slot="pdf-content">
          <div class="payment-status-pdf">
            <b-card
              border-variant="secondary"
              header="會員資料"
              header-border-variant="secondary"
              header-bg-variant="secondary"
              header-text-variant="white"
              align="left"
              class="mb-4 payment-status-card"
            >
              <tables-page
                :tableData="memberData.table_data"
                :tableFields="memberData.table_fields"
              >
                <template #cell(member_birthday)="row">
                  {{ convertRocDate(row.item.member_birthday) }}
                </template>

                <template #cell(join_date)="row">
                  {{ convertRocDate(row.item.join_date) }}
                </template>

                <template #cell(seniority)="row">
                  {{ row.item.seniority_month }}個月 ({{ row.item.seniority_day }}天)
                </template>

                <template #cell(dead_at)="row">
                  {{ convertRocDate(row.item.dead_at, false) }}
                </template>

                <template #cell(stop_history)="row">
                  <template v-if="row.item.stop_history && row.item.stop_history.includes(',')">
                    <div
                      v-for="(item, index) of row.item.stop_history.split(',')"
                      :key="index"
                    >
                      {{ convertRocDate(item.split('~')[0]) }} ~ {{ convertRocDate(item.split('~')[1]) }}
                    </div>
                  </template>

                  <template v-else-if="row.item.stop_history">
                    <div>
                      {{ convertRocDate(row.item.stop_history.split('~')[0]) }} ~ {{ convertRocDate(row.item.stop_history.split('~')[1]) }}
                    </div>
                  </template>
                </template>

              </tables-page>
            </b-card>

            <b-card
              border-variant="secondary"
              header-border-variant="secondary"
              header-bg-variant="secondary"
              header-text-variant="white"
              align="left"
              class="mb-4 payment-status-card"
            >
              <template #header>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="mb-0">會員已繳帳單</h6>

                  <b-button
                    variant="warning"
                    size="sm"
                    v-auth="`update`"
                    @click="openBillAddEdit('new', null, 0)"
                   >
                    新增
                   </b-button>
                </div>
              </template>

              <b-alert show>
                <div class="total-data-area">
                  <div v-for="(item, index) of getTotalInfo('paidBill')" :key="index">
                    {{ item }}
                  </div>
                </div>
              </b-alert>

              <tables-page
                :tableData="paidBill.table_data"
                :tableFields="paidBill.table_fields"
              >
                <template #cell(no)="row">
                  {{ row.index + 1 }}
                </template>

                <template #cell(type)="row">
                  <span :class="getBillTypeColor(row.item.type)">{{ getBillFeeDescription(row.item) }}</span>
                </template>

                <template #cell(dead_at)="row">
                  {{ convertRocDate(row.item.dead_at, false) }}
                </template>

                <template #cell(payment_at)="row">
                  {{ convertRocDate(row.item.payment_at, false) }}
                </template>

                <template #cell(updated_at)="row">
                  {{ convertRocDate(row.item.updated_at) }}
                </template>

                <template #cell(late_payment)="row">
                  <span class="text-danger">{{ row.item.payment_at > row.item.dead_at ? '遲繳' : ''  }}</span>
                </template>

                <template #cell(function)="row">
                  <b-button
                    variant="info"
                    size="sm"
                    v-auth="`update`"
                    @click="openBillAddEdit('edit', row.item)"
                  >
                    編輯
                  </b-button>

                  <b-button
                    variant="danger"
                    size="sm"
                    v-auth="`update`"
                    @click="deleteBill(row.item.id)"
                  >
                    刪除
                  </b-button>
                </template>
              </tables-page>
            </b-card>

            <b-card
              border-variant="secondary"
              header-border-variant="secondary"
              header-bg-variant="secondary"
              header-text-variant="white"
              align="left"
              class="mb-4 payment-status-card"
            >
              <template #header>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="mb-0">會員未繳帳單</h6>

                  <b-button
                    variant="warning"
                    size="sm"
                    v-auth="`update`"
                    @click="openBillAddEdit('new', null, 1)"
                  >
                    新增
                  </b-button>
                </div>
              </template>

              <b-alert show>
                <div class="total-data-area">
                  <div v-for="(item, index) of getTotalInfo('unPaidBill')" :key="index">
                    {{ item }}
                  </div>
                </div>
              </b-alert>

              <tables-page
                :tableData="unPaidBill.table_data"
                :tableFields="unPaidBill.table_fields"
              >
                <template #cell(no)="row">
                  {{ row.index + 1 }}
                </template>

                <template #cell(type)="row">
                  <span :class="getBillTypeColor(row.item.type)">{{ getBillFeeDescription(row.item) }}</span>
                </template>

                <template #cell(dead_at)="row">
                  {{ convertRocDate(row.item.dead_at, false) }}
                </template>

                <template #cell(payment_at)="row">
                  {{ convertRocDate(row.item.payment_at, false) }}
                </template>

                <template #cell(updated_at)="row">
                  {{ convertRocDate(row.item.updated_at) }}
                </template>

                <template #cell(late_payment)="row">
                  <span class="text-danger">{{ row.item.payment_at > row.item.dead_at ? '遲繳' : ''  }}</span>
                </template>

                <template #cell(function)="row">
                  <b-button
                    variant="info"
                    size="sm"
                    v-auth="`update`"
                    @click="openBillAddEdit('edit', row.item)"
                  >
                    編輯
                  </b-button>

                  <b-button
                    variant="danger"
                    size="sm"
                    v-auth="`update`"
                    @click="deleteBill(row.item.id)"
                  >
                    刪除
                  </b-button>
                </template>
              </tables-page>
            </b-card>

            <b-card
              border-variant="secondary"
              header-border-variant="secondary"
              header-bg-variant="secondary"
              header-text-variant="white"
              align="left"
              class="mb-4 payment-status-card"
            >
              <template #header>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="mb-0">會員壞帳帳單</h6>

                  <b-button
                    variant="warning"
                    size="sm"
                    v-auth="`update`"
                    @click="openBillAddEdit('new', null, 2)"
                  >
                    新增
                  </b-button>
                </div>
              </template>

              <b-alert show>
                <div class="total-data-area">
                  <div v-for="(item, index) of getTotalInfo('badDebtBill')" :key="index">
                    {{ item }}
                  </div>
                </div>
              </b-alert>

              <tables-page
                :tableData="badDebtBill.table_data"
                :tableFields="badDebtBill.table_fields"
              >
                <template #cell(no)="row">
                  {{ row.index + 1 }}
                </template>

                <template #cell(type)="row">
                  <span :class="getBillTypeColor(row.item.type)">{{ getBillFeeDescription(row.item) }}</span>
                </template>

                <template #cell(dead_at)="row">
                  {{ convertRocDate(row.item.dead_at, false) }}
                </template>

                <template #cell(payment_at)="row">
                  {{ convertRocDate(row.item.payment_at, false) }}
                </template>

                <template #cell(updated_at)="row">
                  {{ convertRocDate(row.item.updated_at) }}
                </template>

                <template #cell(late_payment)="row">
                  <span class="text-danger">{{ row.item.payment_at > row.item.dead_at ? '遲繳' : ''  }}</span>
                </template>

                <template #cell(function)="row">
                  <b-button
                    variant="info"
                    size="sm"
                    v-auth="`update`"
                    @click="openBillAddEdit('edit', row.item)"
                  >
                    編輯
                  </b-button>

                  <b-button
                    variant="danger"
                    size="sm"
                    v-auth="`update`"
                    @click="deleteBill(row.item.id)"
                  >
                    刪除
                  </b-button>
                </template>
              </tables-page>
            </b-card>

            <b-card
              border-variant="secondary"
              header="會員復會前已繳帳單"
              header-border-variant="secondary"
              header-bg-variant="secondary"
              header-text-variant="white"
              align="left"
              class="payment-status-card"
            >
              <template #header>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="mb-0">會員復會前已繳帳單</h6>

                  <b-button
                    variant="warning"
                    size="sm"
                    v-auth="`update`"
                    @click="openBillAddEdit('new', null, 3)"
                  >
                    新增
                  </b-button>
                </div>
              </template>

              <b-alert show>
                <div class="total-data-area">
                  <div v-for="(item, index) of getTotalInfo('paidBeforeResumptionBill')" :key="index">
                    {{ item }}
                  </div>
                </div>
              </b-alert>

              <tables-page
                :tableData="paidBeforeResumptionBill.table_data"
                :tableFields="paidBeforeResumptionBill.table_fields"
              >
                <template #cell(no)="row">
                  {{ row.index + 1 }}
                </template>

                <template #cell(type)="row">
                  <span :class="getBillTypeColor(row.item.type)">{{ getBillFeeDescription(row.item) }}</span>
                </template>

                <template #cell(dead_at)="row">
                  {{ convertRocDate(row.item.dead_at, false) }}
                </template>

                <template #cell(payment_at)="row">
                  {{ convertRocDate(row.item.payment_at, false) }}
                </template>

                <template #cell(updated_at)="row">
                  {{ convertRocDate(row.item.updated_at) }}
                </template>

                <template #cell(late_payment)="row">
                  <span class="text-danger">{{ row.item.payment_at > row.item.dead_at ? '遲繳' : ''  }}</span>
                </template>

                <template #cell(function)="row">
                  <b-button
                    variant="info"
                    size="sm"
                    v-auth="`update`"
                    @click="openBillAddEdit('edit', row.item)"
                  >
                    編輯
                  </b-button>

                  <b-button
                    variant="danger"
                    size="sm"
                    v-auth="`update`"
                    @click="deleteBill(row.item.id)"
                  >
                    刪除
                  </b-button>
                </template>
              </tables-page>
            </b-card>
          </div>
        </template>
      </html-to-pdf>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>

      <!-- 帳單新增或編輯 modal -->
      <bill-add-edit-modal
        v-if="status.billAddEditModal"
        v-model="status.billAddEditModal"
        :data="data.temp_table_data"
        :isNew="status.isNew"
        @sumit="billAddEdit" />
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import billApi from "@/models/API/billApi";
import { convertRocDate, getBillTypeColor, getBillFeeDescription } from "@/models/HELPERS/common.js";
import HtmlToPdf from '@/components/common/HtmlToPdf';
import BillAddEditModal from"./BillAddEditModal";
import qs from 'qs';

export default {
  name: 'PaymentStatusModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    TablesPage,
    HtmlToPdf,
    BillAddEditModal
  },
  data () {
    return {
      status: {
        isLoading: false,
        billAddEditModal: false,
        isNew: false
      },
      memberData: {
        table_fields: [
          {
            key: "plan",
            label: "加入方案",
          },
          {
            key: "number",
            label: "會員編號",
          },
          {
            key: "member_name",
            label: "姓名",
          },
          {
            key: "member_birthday",
            label: "出生日期",
          },
          {
            key: "member_ID_number",
            label: "身分份字號",
          },
          {
            key: "join_date",
            label: "入會日期",
          },
          {
            key: "seniority",
            label: "年資",
          },
          {
            key: "dead_at",
            label: "身故日期",
          },
          {
            key: "stop_history",
            label: "停效日期",
          }
        ],
        table_data: [],
        page: {},
      },
      paidBill: {
        table_fields: [
          {
            key: "no",
            label: "序號",
          },
          {
            key: "month",
            label: "帳單月份",
          },
          {
            key: "period",
            label: "帳單期別",
          },
          {
            key: "type",
            label: "類型",
          },
          {
            key: "amount",
            label: "互助金",
          },
          {
            key: "dead_at",
            label: "繳款期限",
          },
          {
            key: "payment_at",
            label: "繳款日期",
          },
          {
            key: "payment_source",
            label: "繳款來源",
          },
          {
            key: "remark",
            label: "備註",
          },
          {
            key: "updated_at",
            label: "異動時間",
          },
          {
            key: "late_payment",
            label: "遲繳",
          },
          {
            key: "updated_name",
            label: "編輯人",
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        table_data: [],
        page: {},
        total_data: {
          M: 0,
          Y: 0,
          F: 0,
          S: 0,
          B: 0,
          total: 0
        }
      },
      unPaidBill: {
        table_fields: [
          {
            key: "no",
            label: "序號",
          },
          {
            key: "month",
            label: "帳單月份",
          },
          {
            key: "period",
            label: "帳單期別",
          },
          {
            key: "type",
            label: "類型",
          },
          {
            key: "amount",
            label: "互助金",
          },
          {
            key: "dead_at",
            label: "繳款期限",
          },
          {
            key: "payment_at",
            label: "繳款日期",
          },
          {
            key: "payment_source",
            label: "繳款來源",
          },
          {
            key: "remark",
            label: "備註",
          },
          {
            key: "updated_at",
            label: "異動時間",
          },
          {
            key: "late_payment",
            label: "遲繳",
          },
          {
            key: "updated_name",
            label: "編輯人",
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        table_data: [],
        page: {},
        total_data: {
          M: 0,
          Y: 0,
          F: 0,
          S: 0,
          B: 0,
          total: 0
        }
      },
      badDebtBill: {
        table_fields: [
          {
            key: "no",
            label: "序號",
          },
          {
            key: "month",
            label: "帳單月份",
          },
          {
            key: "period",
            label: "帳單期別",
          },
          {
            key: "type",
            label: "類型",
          },
          {
            key: "amount",
            label: "互助金",
          },
          {
            key: "dead_at",
            label: "繳款期限",
          },
          {
            key: "payment_at",
            label: "繳款日期",
          },
          {
            key: "payment_source",
            label: "繳款來源",
          },
          {
            key: "remark",
            label: "備註",
          },
          {
            key: "updated_at",
            label: "異動時間",
          },
          {
            key: "late_payment",
            label: "遲繳",
          },
          {
            key: "updated_name",
            label: "編輯人",
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        table_data: [],
        page: {},
         total_data: {
          M: 0,
          Y: 0,
          F: 0,
          S: 0,
          B: 0,
          total: 0
        }
      },
      paidBeforeResumptionBill: {
        table_fields: [
          {
            key: "no",
            label: "序號",
          },
          {
            key: "month",
            label: "帳單月份",
          },
          {
            key: "period",
            label: "帳單期別",
          },
          {
            key: "type",
            label: "類型",
          },
          {
            key: "amount",
            label: "互助金",
          },
          {
            key: "dead_at",
            label: "繳款期限",
          },
          {
            key: "payment_at",
            label: "繳款日期",
          },
          {
            key: "payment_source",
            label: "繳款來源",
          },
          {
            key: "remark",
            label: "備註",
          },
          {
            key: "updated_at",
            label: "異動時間",
          },
          {
            key: "late_payment",
            label: "遲繳",
          },
          {
            key: "updated_name",
            label: "編輯人",
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        table_data: [],
        page: {},
        total_data: {
          M: 0,
          Y: 0,
          F: 0,
          S: 0,
          B: 0,
          total: 0
        }
      },
      temp_table_data: {}
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.getBill();
          this.getMemberData();
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.billApi = new billApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.page = Object.assign({}, this.billApi.page);
      // this.getBill();
    },
    convertRocDate,
    getBillTypeColor,
    getBillFeeDescription,
    getMemberData() {
      this.memberData.table_data = [this.data];
    },
    // 查詢帳單
    getBill() {
      this.status.isLoading = true;

      const params = {
        'member_id': this.data.id
      };
      this.billApi.getBill((response) => {
        const res = response.data;

        this.resetArray();

        if (res.data.length > 0) {
          this.dataHandler(res.data[0]);
        }

        this.status.isLoading = false;
      }, params, false)
    },
    resetArray() {
      const key = ['paidBill', 'unPaidBill', 'badDebtBill', 'paidBeforeResumptionBill', 'paidBill'];

      key.forEach(item => {
        this[item].table_data = [];
        this[item].total_data = {
          M: 0,
          Y: 0,
          F: 0,
          S: 0,
          B: 0,
          total: 0
        }
      });
    },
    dataHandler(data) {
      let month = 1, current_period = '';

      data.details.reverse().forEach(item => {
        if (!item.month && current_period !== item.period) {
          month+= 1;
          item.month = month;
        } else if (!item.month) {
          item.month = month;
        }

        current_period = item.period;
      });

      data.details.reverse().forEach(item => {
        if (item.class === 0) {
          this.paidBill.table_data.push(item);
          this.calculateTotal('paidBill', item);
        } else if (item.class === 1) {
          this.unPaidBill.table_data.push(item);
          this.calculateTotal('unPaidBill', item);
        } else if (item.class === 2) {
          this.badDebtBill.table_data.push(item);
          this.calculateTotal('badDebtBill', item);
        } else if (item.class === 3) {
          this.paidBeforeResumptionBill.table_data.push(item);
          this.calculateTotal('paidBeforeResumptionBill', item);
        }
      });
    },
    calculateTotal(key, data) {
      this[key].total_data[data.type]+= data.amount;
      this[key].total_data.total+= data.amount;
    },
    getTotalInfo(key) {
      const { M, Y, F, S, B, total } = this[key].total_data;

      if (this.memberData.table_data.length > 0) {
        return [`${this.memberData.table_data[0].number} ${this.memberData.table_data[0].member_name}`, `互助費 ${M}`, `平台年費 ${Y}`, `上期手續費 ${F}`, `回饋金 ${S}`, `墊繳手續費 ${B}`, `總計 ${total}`];
      }
    },
    // 取消銷帳
    // unRemoveBill(item = {}) {
    //   const r = confirm("確定要取消銷帳？");
    //   const details_data = [{
    //     ...item,
    //     class: 1,
    //     payment_at: '',
    //     payment_source: ''
    //   }]

    //   if (r) {
    //     const params = qs.stringify({
    //       'details': JSON.stringify(details_data),
    //     })

    //     this.billApi.multiRemoveBill((response) => {
    //       this.getBill();
    //     }, params, false)

    //     return true;
    //   }

    //   return false;
    // },
    async convertPdf() {
      await this.$nextTick();

      this.$refs.htmlToPdf.generatePdf();
    },
    openBillAddEdit(type = 'new', item = null, class_type = 0) {
      this.status.isNew = type === 'new' ? true : false;

      this.data.temp_table_data = Object.assign({}, item);

      if (type === 'new') {
        this.data.temp_table_data = {
          member_id: this.data.id,
          class: class_type,
          month: null,
          period: '',
          type: null,
          promotion_name: '',
          promotion_times: '',
          amount: '',
          dead_at: '',
          payment_at: '',
          payment_source: null,
          remark: ''
        }
      }

      this.status.billAddEditModal = true;
    },
    // 新增 || 更新帳單
    billAddEdit() {
      const fun = this.status.isNew ? 'addBill' : 'updateBill';
      const status_text = this.status.isNew ? '新增' : '更新';

      const r = confirm(`確定要${status_text}帳單？`);

      if (r) {
        this.status.isLoading = true;

        this.billApi[fun]((response) => {
          const res = response.data;
          let result = {};

          if (res.code === 0) {
            result = { message: `${status_text}成功`, title: '帳單' };

            this.getBill();
            this.$forceUpdate();

            this.status.billAddEditModal = false;
          } else if (res.code === 1) {
            result = { message: res.msg, title: '帳單' };
          }

          this.billApi.toast(() => {}, result, res.code === 0);

          this.status.isLoading = false;
        }, this.data.temp_table_data, false)
      }
    },
    // 刪除帳單
    deleteBill(id) {
      const r = confirm("確定刪除帳單？");

      if (r) {
        this.billApi.deleteBill((response) => {
          const res = response.data;
          let result = {};

          if (res.code === 0) {
            result = { message: '刪除帳單成功', title: '帳單' };

            this.getBill();
          }

          this.billApi.toast(() => {}, result, res.code === 0);
          this.$forceUpdate();
        }, id, false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-status-modal {
  .payment-status-card {
    font-size: 18px;
    .total-data-area {
      display: grid;
      align-items: center;
      justify-content: flex-start;
      grid-template-columns: repeat(7, 1fr);
      text-align: center;
      font-size: 16px;
      > div:not(:last-child) {
        border-right: 1px solid gray;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/PaymentStatusModal.vue